import React, { createContext, useState } from 'react'
import PropTypes from 'prop-types'

const ContractSearcherContext = createContext()

const ContractSearcherContextProvider = ({ children }) => {
  const [currentContract, setCurrentContract] = useState({})
  const [editMode, setEditMode] = useState(false)

  const updateCurrentContract = (newContract) => {
    setCurrentContract(newContract)
  }

  const updateEditMode = (mode) => {
    setEditMode(mode)
  }

  return (
    <ContractSearcherContext.Provider
      value={{
        currentContract,
        editMode,
        updateCurrentContract,
        updateEditMode
      }}
    >
      {children}
    </ContractSearcherContext.Provider>
  )
}

ContractSearcherContextProvider.propTypes = {
  children: PropTypes.node
}

export { ContractSearcherContext, ContractSearcherContextProvider }
